// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"2ca761f5","264":"31ae5203","480":"1966454b","638":"a1afb06c","702":"46dcbab8","738":"5d973f8c"}[chunkId] + ".chunk.js";
};